export default "__VITE_ASSET__87b93b1c__"